import React from 'react';
import { Truck, Package } from 'lucide-react';
import './TransportSelectorProductPage.css'; // Assuming you have a CSS file for styles

const TransportSelectorProductPage = ({ activityData, selectedValue, onChange }) => {
    const getTransportOptions = () => {
        const options = [];

        if (activityData?.isTransportPartner && activityData?.transportPartnerPrice) {
            options.push({
                id: 'transport',
                value: 'TRANSPORT',
                label: `TRANSPORT     ${activityData.transportPartnerPrice} NOK`,
                price: activityData.transportPartnerPrice,
                icon: <Truck className="transport-icon" />
            });
        }

        if (activityData?.isTransportFree) {
            options.push({
                id: 'hente-selv',
                value: 'HENTE SELV',
                label: 'HENTE SELV     0 NOK',
                price: 0,
                icon: <Package className="transport-icon" />
            });
        }

        return options;
    };

    const transportOptions = getTransportOptions() || [];

    const handleSelect = (option) => {
        onChange({
            option: option.value,
            label: option.label,
            price: option.price
        });
    };

    return (
        <>
        { transportOptions && transportOptions.length > 0 &&
        <li class="list-group-item">
            <div class="info">
                <div class="lbl"> Velg transport</div>
                <div class="text price-block">
                    <div className="transport-selection-section">
                        <div className="transport-options">
                            {transportOptions.map((option) => (
                                <label
                                    key={option.id}
                                    className={`transport-option ${selectedValue === option.value ? 'selected' : ''}`}
                                >
                                    <input
                                        type="radio"
                                        name="transport"
                                        required
                                        value={option.value}
                                        checked={selectedValue === option.value}
                                        onChange={() => handleSelect(option)}
                                        className="transport-radio"
                                    />
                                    <div className="transport-content">
                                        <div className="transport-check">
                                            <div className="check-circle"></div>
                                        </div>
                                        <div className="transport-icon-wrapper">{option.icon}</div>
                                        <div className="transport-details">
                                            <span className="transport-label">{option.label}</span>
                                        </div>

                                    </div>
                                </label>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </li>

        }
        </>
    );
};

export default TransportSelectorProductPage;
